/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ select: NonNullable<unknown>, of: NonNullable<unknown> }} Rich_Pearl_Mule_RushInputs */

const en_rich_pearl_mule_rush = /** @type {(inputs: Rich_Pearl_Mule_RushInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.select} of ${i?.of}`)
};

const de_rich_pearl_mule_rush = /** @type {(inputs: Rich_Pearl_Mule_RushInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.select} von ${i?.of}`)
};

/**
* | output |
* | --- |
* | "{select} of {of}" |
*
* @param {Rich_Pearl_Mule_RushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rich_pearl_mule_rush = /** @type {((inputs: Rich_Pearl_Mule_RushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rich_Pearl_Mule_RushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rich_pearl_mule_rush(inputs)
	return de_rich_pearl_mule_rush(inputs)
});